import cn from "classnames";
import { useAtomValue } from "jotai";
import type { CSSProperties, MouseEvent } from "react";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { WidgetOptions } from "@/shared/types/widgetOptions";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseAiAssistantButtonProps {
    name: WidgetOptions;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useColorButton({
    name,
    setActiveSubMenu,
}: UseAiAssistantButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom(name));

    const uniqueValues = [
        ...new Set(options.map((option) => (option.value as string).toLowerCase())),
    ];

    const isWhiteOrTransparent =
        uniqueValues.includes("transparent") || uniqueValues.includes("#ffffff");

    const colorStyles = cn(styles.color, isWhiteOrTransparent && styles.border);

    const content = (
        <div
            className={colorStyles}
            style={
                {
                    "--color-left": uniqueValues[0],
                    "--color-right": uniqueValues[1] ?? uniqueValues[0],
                } as CSSProperties
            }
        />
    );

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;
        setActiveSubMenu((prev) => (prev?.name === name ? null : { name, anchor: button }));
    };

    return { content, handleClick };
}
